import React, { useEffect } from 'react';
import { LandingHeader } from './components/LandingHeader';
import { LandingHero } from './components/LandingHero';
import { ProblemSolutionSection } from './components/ProblemSolutionSection';
import { TransitionSection } from './components/TransitionSection';
import { DashboardShowcase } from './components/DashboardShowcase';
import { FeaturesGrid } from './components/FeaturesGrid';
import { BenefitsSection } from './components/BenefitsSection';
import { ForWhoSection } from './components/ForWhoSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { FaqSection } from './components/FaqSection';
import { FinalCTASection } from './components/FinalCTASection';
import { LandingFooter } from './components/LandingFooter';

const LandingPage = () => {
  useEffect(() => {
    document.title = 'PastoreApp | Software de gestión para iglesias';
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-white font-sans selection:bg-indigo-500/30 overflow-x-hidden">
      <LandingHeader />
      <main>
        <LandingHero />
        <ProblemSolutionSection />
        <TransitionSection />
        <DashboardShowcase />
        <FeaturesGrid />
        <BenefitsSection />
        <ForWhoSection />
        <HowItWorksSection />
        <FaqSection />
        <FinalCTASection />
      </main>
      <LandingFooter />
    </div>
  );
};

export default LandingPage;
